import { RowStopDto } from "@/dtos";
import { Stop } from "@/entities";

export const formatRowStopDto = (checkpoints: Stop[]): RowStopDto[] => {
    return checkpoints.map((x) => {
        const row: RowStopDto = {
            ...x,
            active: (x.is_active) ? 'Activo' : 'Inactivo',
            city: x.details?.city ?? ''
        }
        return row;
    });
}